import React from 'react';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { CloseIcon, SpinnerIcon, TickIcon } from '@ui-kit-ngs/icons';
export const SelectionButtonExtraContent = styled.span `
  display: inline-block;
  margin: 0 ${({ theme }) => theme.space[2]};
`;
export const HandicapExtraContent = styled(SelectionButtonExtraContent) `
  color: inherit;
  text-align: center;
  opacity: 0.5;
  margin: 0;
  padding: 0 ${({ theme }) => theme.space[2]} 0;
  font-size: ${({ theme }) => theme.fontSizes[0]};
  ${({ theme }) => theme.device === 'mobile' && css `
    display: block;
    padding-bottom: ${theme.space[2]};
    margin-top: -${theme.space[2]};
    font-size: 9px;
  `};
`;
const animationBlink = keyframes `
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const priceAnimation = css `
  animation: ${animationBlink} 300ms ease-in-out 2;
`;
const AnimatedSelectionButtonExtraContent = styled.span `
  display: inline-block;
  margin: 0 ${({ theme }) => theme.space[2]};
  ${({ animate }) => animate && priceAnimation}
`;
const AnimatedSpan = styled.span `
  ${({ animate }) => animate && priceAnimation}
`;
// eslint-disable-next-line complexity
const SelectionButtonSelectionContent = ({ selection, hideName, }) => {
    const { hasPriceDecreased, hasPriceIncreased, isProcessing, isAdding, isRemoving, isGoal, handicap, handicapInfo, name, formattedOdds, goalTranslated, } = selection;
    const priceChangeAnimation = !!(hasPriceDecreased || hasPriceIncreased);
    if (isProcessing) {
        return React.createElement(SpinnerIcon, { height: "11" });
    }
    if (isAdding) {
        return React.createElement(TickIcon, { height: "11" });
    }
    if (isRemoving) {
        return React.createElement(CloseIcon, { height: "11" });
    }
    if (isGoal) {
        return React.createElement("span", null, goalTranslated !== null && goalTranslated !== void 0 ? goalTranslated : 'Goal!');
    }
    if (handicap) {
        return (React.createElement("div", null,
            React.createElement(HandicapExtraContent, null,
                handicapInfo && `${handicapInfo} `,
                `(${handicap})`),
            React.createElement(AnimatedSelectionButtonExtraContent, { animate: priceChangeAnimation }, formattedOdds)));
    }
    if (name && !hideName) {
        return (React.createElement("div", null,
            React.createElement(SelectionButtonExtraContent, null, name),
            React.createElement(AnimatedSelectionButtonExtraContent, { animate: priceChangeAnimation }, formattedOdds)));
    }
    return (React.createElement(AnimatedSpan, { animate: priceChangeAnimation }, formattedOdds));
};
export default SelectionButtonSelectionContent;
